import gql from "graphql-tag";

export default gql`query SearchPostcode($text:String!, $container:String) {
    searchPostcode(text:$text, container:$container) {
      Description
      Highlight
      Id
      Text
      Type
    }
  }`